export type DetectedOs = 'ios' | 'android' | 'windows' | 'macos' | 'linux' | 'other';

// Answers "which store can this visitor install from?" as well as feeding the
// analytics `os` super property, so both read the same sniff.
export const detectOs = (): DetectedOs => {
  const ua = navigator.userAgent.toLowerCase();
  // iPadOS Safari reports itself as a Mac; the touch check separates them.
  const isIpadOs = ua.includes('mac') && navigator.maxTouchPoints > 1;
  if (/iphone|ipad|ipod/.test(ua) || isIpadOs) return 'ios';
  if (ua.includes('android')) return 'android';
  if (ua.includes('windows')) return 'windows';
  if (ua.includes('mac')) return 'macos';
  if (ua.includes('linux')) return 'linux';
  return 'other';
};
